import './commonAssets';

import '../common/stylesheets/modules/details-uff.less';
import '../common/stylesheets/modules/widgets/full-width-background-widget.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget-card-design-v2.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget-card-design.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget.less';
import '../global/tools/mixins.less';
import '../graphicstock/components/markup-mixins.less';
import '../graphicstock/modules/search/searchResults.less';
import '../../assets/common/stylesheets/modules/signup/user-lead-form-innards.less';


import AppLoader from '../react/AppLoader/AppLoader';
import NPSModalLoaderContainer from '../react/NPSModalLoader/NPSModalLoaderContainer';
import ReactToastifyContainer from '../react/ReactToastify/containers/ReactToastifyContainer';
import GraphicDetailsContainer from '../react/Details/containers/GraphicDetailsContainer';
import PopUpsContainer from '../react/PopUps/PopUpsContainer';
import ImageSiteConstants from '../react/common/SiteConstants/ImageSiteConstants';
import EntTrialBanner from "../react/Trials/EntTrialBanner";
import NavApps from "../react/app/NavApps";

AppLoader.load({
  routes: [
    {
      name: 'Details',
      path: new ImageSiteConstants().getDetailsRoute(),
      component: GraphicDetailsContainer,
    },
  ],
  auxApps: {
    ...NavApps,
    'pop-up-container': PopUpsContainer, // FIXME: causes missing matching <div> in <section>
    'nps-modal': NPSModalLoaderContainer,
    'react-toastify-container': ReactToastifyContainer, // FIXME: causes missing matching <div> in <section>
  },
  propBasedApps: {
    'entTrialBanner': EntTrialBanner
  },
});
